export { default } from './PageComposableHeaderTitle'
